<template>
  <div>
    <commonTable
      :tableData="tableData"
      :loading="loading"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      :currentPage="currentPage"
      :total="total"
    >
      <template v-slot:table>
        <el-table-column align="center" width="70">
          <template slot-scope="scope">
            <el-radio v-model="currentRowId" :label="scope.row.goodsId" @change="handleSelectionChange(scope.row)" >
              {{ ' ' }}
            </el-radio>
          </template>
        </el-table-column>
        <el-table-column
          prop="goodsId"
          align="center"
          :label="$t('marketing', 'productId')"
          show-overflow-tooltip
        />
        <el-table-column prop="goodsName" align="center" :label="$t('marketing', 'product')" />
        <el-table-column align="center" prop="goodsTypeName" :label="$t('marketing', 'category')" />
        <el-table-column prop="price" align="center" :label="$t('marketing', 'price')">
          <template slot-scope="scope">
            {{ (scope.row.price / 100).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column prop="stockNum" align="center" :label="$t('marketing', 'stock')" />
        <el-table-column prop="dealNum" width="100" align="center" :label="$t('marketing', 'totalSales')" />
        <el-table-column align="center" :label="$t('marketing', 'publishTime')">
          <template slot-scope="scope">
            {{ setGetDataTimeSec(scope.row.createTime) }}
          </template>
        </el-table-column>
      </template>
    </commonTable>
  </div>
</template>

<script>
import { getGoodsInfoPC } from "@/api/marketingActivities";
import commonTable from "@/components/common/commonTable";
import { getDataTimeSec } from "@/utils";
import i18nMixin from '@/mixins/i18nMixin';

export default {
  mixins: [i18nMixin],
  data() {
    return {
      tableData: [],
      currentPage: 1, //当前页
      pageSize: 10, //显示条数
      loading: false, //表格加载
      total: 0, //总条数
      currentRowId:'',
      multipleSelection: {}
    };
  },
  components: {
    commonTable,
  },
  computed: {
    setGetDataTimeSec() {
      return (val) => getDataTimeSec(val);
    },
  },
  created() {
    this.getGoodsInfoPC();
    
    // 监听语言变化，强制更新组件
    this.$root.$on('language-changed', () => {
      this.$forceUpdate();
    });
  },
  beforeDestroy() {
    // 清理事件监听
    this.$root.$off('language-changed');
  },
  methods: {
    async getGoodsInfoPC() {
      let data = {
          pageNum: this.currentPage, //当前页
          pageSize: this.pageSize, //显示条数
          isOrdinary:1            //普通商品
      }
       try {
        this.loading = true;
        const result = await getGoodsInfoPC(data);
        this.loading = false;
        const { pageInfo } = result.data;
        const { total, list } = JSON.parse(pageInfo);
        console.log(JSON.parse(JSON.stringify(list)))
        this.tableData = list;
        this.total = total;
      } catch (error) {
        this.loading = false;
        console.log(error)
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      console.log(val)
      this.getGoodsInfoPC();
    },
    handleCurrentChange(val) {
      console.log(val)
      this.currentPage = val;
      this.getGoodsInfoPC();
    },
    handleSelectionChange(val) {
      console.log(val)
      this.currentRowId = val.goodsId;
      this.multipleSelection = val;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
